import { Container, SxProps, Theme } from "@mui/material";
import React from "react";

interface ContainerBlockProps {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
  ref?: any;
}

const ContainerBlock: React.FC<ContainerBlockProps> = ({
  children,
  sx,
  ref,
}) => {
  return (
    <Container
      ref={ref}
      disableGutters
      sx={{
        maxWidth: {
          xl: 1200,
          xxl: 1536,
        },
        ...sx,
      }}
    >
      {children}
    </Container>
  );
};

export default ContainerBlock;
